<button type="button"
  class="text-center button-container btn-delete-icon"
  #deletePopover="ngbPopover"
  #deleteButton
  [attr.aria-label]="ariaLabel"
  [id]="instanceId"
  [attr.tabindex]="deleteTabIndex"
  placement="left" [ngbPopover]="popContent" container="body"
  (click)="emitData()"
  (shown)="focusPopoverDialog()" (hidden)="returnFocusToCell()"
  pTooltip="{{'icon.delete.tooltip'|translate}}" tooltipPosition="left">
  <ng-template #popContent>
    <div role="dialog"
         [attr.aria-labelledby]="titleId"
         tabindex="-1"
         (keydown.tab)="onDialogTab($event, false)"
         (keydown.shift.tab)="onDialogTab($event, true)">
      <div class="message-delete">
          <p [id]="titleId">{{messageDelete}}</p>
      </div>
      <div class="button-response">
        <breeze-button #cancelBtn [isSecondary]="true" [showTooltip]="false"
          buttonText="{{'btn.cancel.label' | translate }}"
          (clicked)="deletePopover.close()"></breeze-button>
        <breeze-button #confirmBtn [isPrimary]="true" [showTooltip]="false"
          buttonText="{{'btn.confirm.label' | translate }}"
          (clicked)="confirm(); deletePopover.close()"></breeze-button>
      </div>
    </div>
  </ng-template>
  <i [iconName]="'delete'" [fillColor]="'#707070'" aria-hidden="true" tabindex="-1"></i>
</button>